(($, Drupal) => {
  Drupal.behaviors.headerSelect = {
    attach: function attach(context) {
      $('.js-header-select', context).once('headerSelect').each((index, element) => {
        const $select = $(element);
        const $trigger = $select.find('.language-select__inner');
        const $dropdown = $select.find('.language-select__dropdown');

        $select.on('click', () => {
          $select.toggleClass('active');
        });


        $trigger.on('click', () => {
          $trigger.toggleClass('active');
          $dropdown.toggleClass('active');
        });

        $select.parents('body').mouseup((e) => {
          if (!$select.is(e.target) && $select.has(e.target).length === 0) {
            if ($trigger.hasClass('active')) {
              $trigger.removeClass('active');
              $dropdown.removeClass('active');
            }
          }
        });
      });
    },
  };

  Drupal.behaviors.headerMenuMobile = {
    attach: function attach(context) {
      if ($('.menu-mobile-burger').data('init')) {
        return; // avoid multiple attach
      }
      $('.menu-mobile-burger').data('init', true);
      $('.menu-mobile-burger').on('click', function () {
        $(this).toggleClass('opened');
        $('.header__right').toggleClass('active');
      });

      $('.menu-level-0 .menu-item--expanded').on('click', function () {
        const submenu = $(this).find('.menu-level-1');
        if (submenu.css('display') === 'none') {
          $(this).find('.menu-level-1').addClass('active');
          $(this).addClass('open-menu');
        } else {
          $(this).find('.menu-level-1').removeClass('active');
          $(this).removeClass('open-menu');
        }
      });
    },
  };
})(jQuery, Drupal);
